<div class="ProseMirror margin-py-16 space-after-paragraph" [innerHtml]="htmlContent"></div>
